import React, { useState } from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { DashboardDonationsManager } from '../../components/donations/DashboardDonationsManager';
import { CampaignEditorPage } from '../public/CampaignEditorPage';
import { DonationCampaign } from '../../types';
import { Heart, Plus, ExternalLink } from 'lucide-react';
import { saveViewScroll, restoreViewScroll, resetScrollToTop } from '../../utils/scrollRestoration';

interface DonationsManagementPageProps {
  onNavigateToPublic?: () => void;
}

export const DonationsManagementPage: React.FC<DonationsManagementPageProps> = ({
  onNavigateToPublic
}) => {
  const [view, setView] = useState<'manager' | 'editor'>('manager');
  const [editingCampaign, setEditingCampaign] = useState<DonationCampaign | null>(null);

  const handleCreateNew = () => {
    saveViewScroll('donations_manager');
    setEditingCampaign(null);
    setView('editor');
    resetScrollToTop();
  };

  const handleEditCampaign = (campaign: DonationCampaign) => {
    saveViewScroll('donations_manager');
    setEditingCampaign(campaign);
    setView('editor');
    resetScrollToTop();
  };

  if (view === 'editor') {
    return (
      <CampaignEditorPage
        campaign={editingCampaign}
        onBack={() => {
          setView('manager');
          restoreViewScroll('donations_manager');
        }}
        onSaved={() => {
          setView('manager');
          restoreViewScroll('donations_manager');
        }}
      />
    );
  }

  return (
    <div className="w-full space-y-6">
      <PageHeader
        badgeText="Kewangan & Tabung"
        badgeIcon={Heart}
        title="Pengurusan Tabung Infaq"
      >
        <div className="flex items-center gap-2">
          {onNavigateToPublic && (
            <button
              type="button"
              onClick={onNavigateToPublic}
              className="px-3.5 py-2 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 font-extrabold text-xs rounded-2xl transition-all shadow-xs flex items-center gap-1.5 cursor-pointer"
            >
              <ExternalLink className="w-3.5 h-3.5 text-slate-500" />
              <span>Lihat Laman Awam</span>
            </button>
          )}

          <button
            type="button"
            onClick={handleCreateNew}
            className="px-4 py-2 bg-asmm-red hover:bg-asmm-crimson text-white font-extrabold text-xs rounded-2xl transition-all shadow-md flex items-center gap-2 cursor-pointer"
          >
            <Plus className="w-4 h-4" />
            <span>Cipta Kempen Baru</span>
          </button>
        </div>
      </PageHeader>

      <DashboardDonationsManager
        onNavigateToCreate={handleCreateNew}
        onNavigateToCampaign={(campaignId) => {
          window.open(`/donations/${campaignId}`, '_blank');
        }}
        setActiveTab={onNavigateToPublic ? () => onNavigateToPublic() : undefined}
      />
    </div>
  );
};
